// extracted by mini-css-extract-plugin
export default {"moduleWrapper":"TwoPictures_moduleWrapper__ctgtb","firstImage":"TwoPictures_firstImage__MyIiz","secondImage":"TwoPictures_secondImage__jzjwq"};